module.exports = __webpack_public_path__ + "static/avril-spray-7f3c6561fb0a9763dea00b49bc7089cc.gif";